(function () {
    'use strict';

    angular.module('NaviaqWebApp').controller('personDetailsModalAdministrationController', personDetailsModalAdministrationController);

    personDetailsModalAdministrationController.$inject = [
        '$translate',
        '$rootScope',
        '$scope',
        '$windowInstance',
        'person',
        'currentFormType',
        'formTypes',
        'personService',
        'locations',
        'contractors',
        'includeConglomerate'
    ];

    function personDetailsModalAdministrationController(
        $translate,
        $rootScope,
        $scope,
        $windowInstance,
        person,
        currentFormType,
        formTypes,
        personService,
        locations,
        contractors,
        includeConglomerate
    ) {
        $scope.person = {};
        $scope.close = close;
        $scope.validateForm = validateForm;
        $scope.selectedLocationIds = [];
        $scope.contractors = _.orderBy(contractors || [], [c => (c.name || '').toLowerCase()]);
        $scope.showCompanyPicker = includeConglomerate && $scope.contractors.length > 1;
        $scope.selectedContractorId = (currentFormType === formTypes.edit && person && person.contractorId)
            ? person.contractorId
            : $rootScope.authData.contractorId;

        $scope.contractorOptions = {
            dataSource: new kendo.data.DataSource({
                data: $scope.contractors
            }),
            dataValueField: 'contractorId',
            dataTextField: 'name',
            filter: 'contains'
        };

        const sortedLocations = locations.map(function(location) {
            const cleanName = location.name ? location.name.trim() : '';
            const displayWithNumber = `${cleanName} - ${location.locationNumber}`;

            return {
                locationNumber: location.locationNumber,
                displayName: displayWithNumber,
                sortName: cleanName
            };
        }).sort((a, b) => a.sortName.localeCompare(b.sortName, 'nb-NO', {sensitivity: 'base'}));

        $scope.locationOptions = {
            dataSource: new kendo.data.DataSource({
                data: sortedLocations
            }),
            dataValueField: 'locationNumber',
            dataTextField: 'displayName',
            filter: 'contains',
            filterFields: ['displayName', 'sortName', 'locationNumber'],
            autoClose: false
        };

        initController();

        function initController() {
            if (currentFormType === formTypes.edit && person) {
                $scope.person = person;

                // Extract location IDs from person data
                if ($scope.person.locations && $scope.person.locations.length > 0) {
                    $scope.selectedLocationIds = _.map($scope.person.locations, 'locationNumber');
                } else if ($scope.person.locationPersons && $scope.person.locationPersons.length > 0) {
                    $scope.selectedLocationIds = _.map($scope.person.locationPersons, 'locationNumber');
                }

                // Update Kendo widget after Angular digest cycle
                $scope.$evalAsync(function() {
                    var multiselect = $('#location-selector').data("kendoMultiSelect");
                    if (multiselect) {
                        multiselect.value($scope.selectedLocationIds);
                    }
                });
            }
        }

        function validateForm(event) {
            event.preventDefault();
            if ($scope.validator.validate()) {
                $rootScope.$broadcast('showBusyIndicator', {
                    id: 'personDetailsModalIndicator',
                    destination: '.k-widget.k-window',
                    overlay: true
                });

                switch (currentFormType) {
                    case formTypes.add:
                        extendLocationPersons();
                        $scope.person.contractorId = $scope.selectedContractorId;
                        personService.addPerson($scope.person)
                            .then(function (personId) {
                                close(personService.getContactPersonByPersonId(personId))
                            })
                            .catch(() => close());
                        break;
                    case formTypes.edit:
                        extendLocationPersons();
                        $scope.person.contractorId = $scope.selectedContractorId;
                        $scope.person.contractor = _.find($scope.contractors, { contractorId: $scope.selectedContractorId }) || $scope.person.contractor;
                        personService.updatePerson($scope.person)
                            .then(person => close($scope.person))
                            .catch(() => close());
                        break;
                    default:
                        close();
                        break;
                }
            }
        }

        function extendLocationPersons() {
            // Get the latest selection from the multiselect widget
            var multiselect = $('#location-selector').data("kendoMultiSelect");
            if (multiselect) {
                $scope.selectedLocationIds = multiselect.value();
            }

            var locationPersons = [];

            _.forEach($scope.selectedLocationIds, function(locationId) {
                locationPersons.push({
                    locationNumber: locationId,
                    personId: $scope.person.personId
                });
            });

            $scope.person.locationPersons = locationPersons;
        }

        function close(param) {
            $rootScope.$broadcast('hideBusyIndicator', 'unitDetailsModalIndicator');
            $windowInstance.close(param);
        }
    }
})();
